module.exports = __webpack_public_path__ + "img/move.4e35b860.svg";